
const digest = 'e827e8e61d786521d8a9e1123370e68f63c01d3d7934d01ece9714a8523f3cf2';
const classes = {"container":"_container_d2yts_1"};
const css = `._container_d2yts_1 {
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
  height: 100%;
  padding: 0 10px 10px;
  gap: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  